import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ContractService } from '../services/contract.service';
import { CustomerService } from '../services/customer.service';
import { ServiceService } from '../services/service.service';
import { SpecialService } from '../services/special.service';
import { Customer } from '../models/customer.model';
import { Contract } from '../models/contract.model';
import { Service } from '../models/service.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'contract',
  templateUrl: '../views/core/contract.html',
  providers: [ContractService, CustomerService, ServiceService, SpecialService]
})
export class ContractComponent{
  public title: string;
  public contracts: Contract[];
  public customers: Customer[];
  public services: any[];
  public serviceDetails:any;
  public products: any[];
  public founds: any[];
  public cfounds: any[];

  public showCustomerInfo: Customer;
  public showServiceInfo: Service;
  public submitContractModel: Contract;
  public employee_id:number;
  public message: any;
  public mode: string;
  public searchText:string;
  public searching: boolean;
  public showProducts:boolean;
  public customerSelected:boolean;
  public serviceSelected:boolean;
  public wait:boolean;
  public contractPrivilege:number;
  public privileges:Privileges[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private contractService: ContractService,
    public sharedVariables: VariableService,
    public customerService: CustomerService,
    public serviceService: ServiceService,
    private specialService: SpecialService
  )
  {
      this.title = "Contract module";
      this.mode = "submit-add";
      this.submitContractModel = new Contract(null,null,null,'',
                                              false,null,'',null,null,null,null,null,null);
      this.showCustomerInfo = new Customer(null,null,null,null,null,null,null,null,null);
      this.showServiceInfo = new Service(null,null,null);
      this.customerSelected = false;
      this.serviceSelected = false;
      this.wait = true;
      this.contractPrivilege = null;
  }

  /*ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession()
    if(this.sharedVariables.login){
      console.log("Sesión valida bingo",this.sharedVariables.login);
      this.getAllContracts();
      this.getAllCustomers();
      this.getAllServices();
    }
    else
      this.title = "Error, Sesión no iniciada";
      console.log("Error,Sesion no iniciada");
      console.log(this.sharedVariables.validSession());
  }*/

  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.contractPrivilege == 1){
                                    this.getAllContracts();
                                    this.getAllCustomers();
                                    this.getAllServices();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllContracts()
  {
    this.contractService.getContracts().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.contracts = result.data;
          console.log(this.contracts);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getAllServices()
  {
    this.serviceService.getServices().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.services = result.data;
          console.log("show services - > ",this.services);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getAllProducts(id:number)
  {
    console.log(id);
    this.specialService.getProducts_IN_Service(id).subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.products = result.data;
        //  this.services = this.ServiceSerialize(this.services);
          console.log("show services - > ",this.products);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  chooseCustomer(Pcustomer:Customer)
  {
    this.showCustomerInfo = Object.assign({}, Pcustomer);
    console.log("I select this",this.showCustomerInfo);
    this.searching = false;
  }

  chooseService(Pservice:Service)
  {
    this.products = null;
    this.showProducts = false;
    this.showServiceInfo = Object.assign({}, Pservice);
    this.submitContractModel.cost = this.showServiceInfo.price;
    this.submitContractModel.Service_ID = this.showServiceInfo.ID;
    this.searching = false;
    this.searchText = null;
    this.customerSelected = true;
    console.log("I select this",this.submitContractModel);
  }

  getAllCustomers()
  {
    this.customerService.getCustomers().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.customers = result.data;
          console.log(this.customers);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  onSubmit()
  {
    if(this.mode == "submit-add")
    {

      this.submitContractModel.Customer_ID = this.showCustomerInfo.ID;
      this.submitContractModel.Employee_ID = this.employee_id;
      console.log("DATA TO LOAD",this.submitContractModel);
      this.saveContract();
      setTimeout(()=> {
                        this._router.navigate(['/impresion']);
                      },this.sharedVariables.timeToLoad);
    }else{
      this.updateContract();
    }

    this.submitContractModel = new Contract(null,null,null,'',
                                            false,null,'',null,null,null,null,null,null);
    this.mode = "submit-add";
    this.getAllContracts();
    console.log("mode",this.mode);
  }

  saveContract()
  {
    this.contractService.addContract(this.submitContractModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  validSession()
  {
    console.log(GLOBAL.sessionInfo.login);
    if(GLOBAL.sessionInfo.login)
      return true;
    else
      return false;
  }

  editContract(pContract: Contract)
  {
    this.mode = "submit-update";
    this.submitContractModel = Object.assign({}, pContract);
    console.log("Checkout objects");
    console.log("mode",this.mode);
  }

  updateContract()
  {
      let id = this.submitContractModel.ID;
      console.log("objeto update ",this.submitContractModel);
      this.contractService.updateContract(id,this.submitContractModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
  }

  deleteContract(id: number)
  {
    this.contractService.deleteContract(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllContracts();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  showResults(event: any) : void
  {
    if (event.target.value.length >= 3) {
      if(event.target.value.toLowerCase() != 'todos')
      {
        this.searching = true;
        this.founds = this.services.filter(service => service.name.match(event.target.value));
        console.log(this.founds);
      }
      else{
        this.founds = this.services;
      }
    } else {
      this.searching = false;
    }
  }

  showResultsCustomers(event: any) : void
  {
    if (event.target.value.length >= 3) {
      if(event.target.value.toLowerCase() != 'todos')
      {
        this.searching = true;
        this.cfounds = this.customers.filter(customer => customer.name.match(event.target.value));
        console.log(this.cfounds);
      }
      else{
        this.cfounds = this.customers;
      }
    } else {
      this.searching = false;
    }
  }

  cleanObject()
  {
    this.submitContractModel = new Contract(null,null,null,'',
                                            false,null,'',null,null,null,null,null,null);
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.employee_id = response.data[0].id;
            this.contractPrivilege = response.data[0].contract;
            console.log("Privilegios del usuario",response.data[0]);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  showMessage()
  {
    this.message = "hola";
    console.log("Greetings from drops");
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/contract.component.ts